import { Permissions } from 'src/app/core/common';
import { NestedPermissions } from './type-definition';
import { AllPermissionsKeys } from 'src/app/core/common/all-permissions-keys.enum';

export const NESTED_PERMISSIONS: NestedPermissions = new Map([
  // home page
  [
    AllPermissionsKeys.HomePage,
    [
      // Permissions.HomePage_Student_Chart,
      // Permissions.HomePage_Teacher_Chart,
      // Permissions.HomePage_Bill_Chart,
      // Permissions.HomePage_Minutes_Chart,
      Permissions.HomePage_OnLineTeacher_Chart,
      Permissions.HomePage_OnLineStudent_Chart,
      Permissions.HomePage_Teacher_Message,
      Permissions.HomePage_Student_Message,
      // Permissions.HomePage_Peak_Message,
      // Permissions.HomePage_Student_Report,
      // Permissions.HomePage_Teacher_Report,
      // Permissions.HomePage_Calls_Report,
      // Permissions.HomePage_MissedCalls_Report,
      // Permissions.HomePage_GeneralCalls_Report,
      // Permissions.HomePage_TeacherPerformance,
      // Permissions.HomePage_Reviews,
      Permissions.HomePage_Reports,
      // Permissions.HomePage_AppReport,
      Permissions.HomePage_AddTeacher,
      // Permissions.HomePage_CALLS_REPORT_CHART,
      // Permissions.HomePage_PEAKTIME_Report_Chart,
    ],
  ],
  // reports
  [
    AllPermissionsKeys.Reports,
    [
      Permissions.Reports_Teacher,
      Permissions.Reports_Student,
      Permissions.Reports_Call,
      Permissions.Reports_Detailed_Call,
      // Permissions.Reports_Blocked_Student,
      Permissions.Reports_Performance_Teacher,
      Permissions.Reports_Performance_Student,
      Permissions.Reports_Reviews,
      Permissions.User_Management_Admin_Users_Customer_Service,
      // Permissions.Reports_Dependent,
      Permissions.Reports_Student_Packages,
      Permissions.Reports_Sessions,
      // Permissions.Reports_OnlineMinutes_Teacher,
      // Permissions.Reports_PeakTime,
      Permissions.Reports_NotificationReport,
      Permissions.Reports_Reservation,
      Permissions.Reports_PaymentTransaction,
      Permissions.Reports_Firebase,
      Permissions.Reports_Student_Info,
      // Permissions.Reports_Admin_Reviews,
      // Permissions.Reports_Admin_Reviews_Approve,
      // Permissions.Reports_Admin_Reviews_Edit,
      // Permissions.Reports_App_Rating,
      // Permissions.Reports_Survey,
      Permissions.Reports_Insolvent_Requests,
      Permissions.Reports_Products_Payments,
      // Permissions.Reports_Student_Plans,
      // Permissions.Reports_Delete_Students_Plans,
      // Permissions.Reports_Donations,
      // Permissions.Reports_Beneficiaries,
      Permissions.Reports_Total_Duration,
      Permissions.Reports_Teacher_Reservation,
      // Permissions.Fatiha_Sessions,
    ],
  ],

  // settings

  [
    AllPermissionsKeys.Setting,
    [
      Permissions.Setting_General,
      // Permissions.Setting_Add_Student_Package,
      Permissions.Setting_Add_Promo_Package,
      Permissions.Setting_Add_Special_Student_Package,
      Permissions.Setting_Add_Promo,
      Permissions.Setting_Category,
      // Permissions.Setting_Peak_Hour,
      Permissions.Setting_Dynamic_Link,
      Permissions.Setting_Banner,
      // Permissions.Setting_Call_Shared_Files,
      Permissions.Setting_Help_FAQs,
      Permissions.Setting_Help_FAQs_ADD_EDIT,
      Permissions.Setting_Help_Categories,
      Permissions.Send_Insolvent_Code,
    ],
  ],

  // sessions

  // [
  //   AllPermissionsKeys.Sessions,
  //   [
  //     Permissions.Session_Evaluate_Male,
  //     Permissions.Session_Evaluate_Female,
  //     Permissions.Session_Update_Session_Record,
  //     Permissions.Session_Records_Male,
  //     Permissions.Session_Records_Female,
  //     Permissions.Session_Records_Boy,
  //     Permissions.Session_Records_Girl,
  //   ],
  // ],
  //white-labels
  // [AllPermissionsKeys.Statistics, [Permissions.Statistics]],

  // user management
  [
    AllPermissionsKeys.UserManagement,
    [
      Permissions.User_Management_Update_Teacher_Request_Info,
      Permissions.User_Management_Admin_Users,
      // Permissions.User_Management_View_Student_Dependents,
      // Permissions.User_Management_Upgrade_Students_Request,
      // Permissions.User_Management_Upgrade_DependentManager_Requests,
      // Permissions.User_Management_Report_Student,
      // Permissions.User_Management_Report_Teacher,
      Permissions.User_Management_Disable_Student_Buy,
      Permissions.User_Management_Disable_Student_Call,
      Permissions.User_Management_Disable_Student_Account,
      Permissions.User_Management_Student_Category,
      Permissions.User_Management_Student_Disable_Recording,
      Permissions.User_Management_Reset_Balance,
      Permissions.User_Management_Reset_Rating_teacher,
      Permissions.User_Management_Disable_Teacher_Account,
      Permissions.User_Management_Delete_Teacher,
      Permissions.User_Management_Disable_Student_Reservation,
      Permissions.User_Management_Teacher_Category,
      Permissions.User_Management_Teacher_Receivables,
      Permissions.User_Management_Student_Packages,
      // Permissions.User_Management_Teacher_Join_US,
      // Permissions.User_Management_Student_Join_US,
      // Permissions.User_Management_Beneficiaries,
      Permissions.User_Management_Edit_Beneficiary_Balance,
      Permissions.User_Management_Grant_Management,
      Permissions.User_Management_Reset_Password,
      Permissions.USER_MANAGEMENT_SET_TEMP_PASSWORD,
      Permissions.USER_MANAGEMENT_VIEW_DEVICE_INFO,
    ],
  ],

  // upload

  [
    AllPermissionsKeys.BulkUpload,
    [
      // Permissions.UploadDate_Student,
      // Permissions.UploadDate_Student_Plan,
      Permissions.UploadDate_Teacher,
      // Permissions.UploadDate_Update_Student,
    ],
  ],
  // Exported Reports
  [AllPermissionsKeys.ExportedReports, [Permissions.Setting_Exported_Report]],
  // Marketplace
  [
    AllPermissionsKeys.Marketplace,
    [
      // Permissions.Setting_Products,
      Permissions.Setting_Package,
    ],
  ],
  // send msg
  [AllPermissionsKeys.SendMsg, [Permissions.HomePage_SendMessage]],
  // [AllPermissionsKeys.Fatiha, [Permissions.Fatiha_Requests]],
]);
